export default __webpack_public_path__ + "static/media/1.e90d8e2a.png";